import React from 'react'
import { fetchAnalysisEditorEnabled } from '../services/analysisService'

export function useAnalysisEditorEnabled() {
  const [enabled, setEnabled] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    let mounted = true
    ;(async () => {
      try {
        const ok = await fetchAnalysisEditorEnabled()
        if (!mounted) return
        setEnabled(ok)
      } catch {
        if (!mounted) return
        setEnabled(false)
      }
    })()
    return () => {
      mounted = false
    }
  }, [])

  return enabled
}

